<template>
	
	
	<div class="row ss-finished">

		<div class="col-md-6 offset-md-3 mb-2 mt-4" v-loading="thinking.save">

			<div class="form">


				<!--<div class="text-center ss-studio">
					<img :src="selectedStudio.image" class="mb-3 img img-fluid img-thumbnail" style="max-width: 100px; margin: 0px auto" />
					<h3 class="mb-1" style="color: #cc6600">{{selectedStudio.title}}</h3>
					<h5>{{selectedStudio.features}}</h5>
					<h5 class="mb-1">{{selectedStudio.street}}</h5>
					<h5>{{selectedStudio.city}} {{selectedStudio.state}} &nbsp;{{selectedStudio.zip}}</h5>
					<h5>{{selectedStudio.phone}}</h5>
				</div>

				<hr />-->

				<p class="lead text-center mb-2">
					Your Membership
				</p>

				<div class="text-center">
					<h3 class="mb-1" style="color: #cc6600" v-html="$parseHtml(selectedPlan.title)"></h3>
					<h5>${{selectedPlan.price}}</h5>					
				</div>
				<div class="text-center">
					<div v-for="(item, i) in $store.state.steps.five.intro" :key="i" v-html="$parseHtml(item)"></div>
					<a href="/my-account" class="btn btn-primary btn-lg">{{$store.state.steps.five.nextButtonText}}</a>
				</div>
				
				

			</div>

			
			
		</div>

		

	</div>

	
	
</template>

<script>
	
	import { mapGetters } from "vuex";
	import { rest } from "@/utilities/rest.js";
	import FinePrint from "./FinePrint";
	import Authorization from "./Authorization";

	export default {
		name: "payment",
		components: {
			
		},
		data() {
			return {

				state: {
					
				},

				errorsInternal: {
					
				},

				thinking: {
					save: false
				}			

												
			}
		},

		created() {
			//if (!this.selectedStudio || !this.selectedPlan) {
			//	this.$router.push({ name: "select-studio" });
			//}
			if (!this.selectedPlan) {
				this.$router.push({ name: "select-membership" });
			}
		},

		computed: {
			...mapGetters({
				selectedStudio: "selectedStudio",
				selectedPlan: "selectedPlan",
				locations: "locations",
				plans: "plans",
				profile: "profile",
				payment: "payment"
			})
			
		},

		methods: {


			
			
		},

		watch: {
			
		}
	}
</script>

